export const processSteps = [
  {
    step: 1,
    title: 'Tell Me About Your Project',
    description:
      'Complete a short intake form and share your content, branding, and inspiration.',
  },
  {
    step: 2,
    title: 'Receive Your Project Proposal',
    description:
      'I review your request and send a clear proposal with scope, pricing, and timeline.',
  },
  {
    step: 3,
    title: 'Approve and Pay Securely',
    description:
      'Approve the proposal and pay through Stripe to lock in your project start date.',
  },
  {
    step: 4,
    title: 'Design, Build and Launch',
    description:
      'I design and build your site, gather feedback, and launch it live with ongoing support options.',
  },
];
